import React from 'react';
import { useTranslation } from 'react-i18next';
import valueFeelEasy from '../assets/images/value-feel-easy.png';
import valueProgress from '../assets/images/value-progress.svg';
import valueDecodeEmotions from '../assets/images/value-decode-emotions.svg';
import valueSafety from '../assets/images/value-safety.svg';
import valueSaveMoments from '../assets/images/value-save-moments.png';

interface Benefit {
    icon: string;
}

const Benefits: React.FC = () => {
    const { t } = useTranslation();

    const benefitIcons: Benefit[] = [
        {
            icon: valueFeelEasy
        },
        {
            icon: "https://cdn.prod.website-files.com/65d1995bebc2cbfa914e45d5/65d5634c8be1543faa74b98f_Benefit%20Icon%2002.svg"
        },
        {
            icon: valueDecodeEmotions
        },
        {
            icon: valueSafety
        },
        {
            icon: valueProgress
        },
        {
            icon: valueSaveMoments
        }
    ];

    return (
        <div>
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-section-large">
                        <div className="benefit-component">
                            <div className="benefit-top-content">
                                <div data-w-id="e8128d4d-2228-524e-84a5-7e360c2afaf7" className="heading-wrapper">
                                    <h2 className="heading-style-h2">{t('benefits.heading')}</h2>
                                    <div style={{ height: '14.3984px' }} className="line-color-light-golden"></div>
                                </div>
                                <p
                                    data-w-id="e85af3cb-681d-34d2-171a-81e46c02765f"
                                    style={{
                                        opacity: 1,
                                        transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                                        transformStyle: 'preserve-3d'
                                    }}
                                    className="text-size-small"
                                >
                                    {t('benefits.subheading')}
                                </p>
                            </div>
                            <div className="padding-bottom padding-large"></div>
                            <div className="w-layout-grid benefit-grid">
                                {benefitIcons.map((benefit, index) => (
                                    <div
                                        key={index}
                                        data-w-id={`benefit-item-${index}`}
                                        style={{
                                            opacity: 1,
                                            transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                                            transformStyle: 'preserve-3d'
                                        }}
                                        className="benefit-items"
                                    >
                                        <img
                                            src={benefit.icon}
                                            loading="lazy"
                                            alt={t(`benefits.items.${index}.title`)}
                                            className="benefit-icon"
                                            style={
                                                index === 0 ? { width: '100px', height: '100px', objectFit: 'contain' } :
                                                index === 3 ? { width: '100px', height: '100px', objectFit: 'contain' } :
                                                index === 5 ? { width: '100px', height: '100px', objectFit: 'contain' } :
                                                undefined
                                            }
                                        />
                                        <div className="benefit-info-wrapper">
                                            <h3 className="heading-style-h3">{t(`benefits.items.${index}.title`)}</h3>
                                            <p className="text-size-regular">{t(`benefits.items.${index}.description`)}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Benefits;
